import { render, staticRenderFns } from "./AdminViewAssignStatusOnContactSDData.vue?vue&type=template&id=010e9f5b&scoped=true"
import script from "./AdminViewAssignStatusOnContactSDData.vue?vue&type=script&lang=js"
export * from "./AdminViewAssignStatusOnContactSDData.vue?vue&type=script&lang=js"
import style0 from "./AdminViewAssignStatusOnContactSDData.vue?vue&type=style&index=0&id=010e9f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e9f5b",
  null
  
)

export default component.exports